export default "__VITE_ASSET__CLI2Q6TA__"